/* ============================================================
   US-Parts24 · Weiterleitungs-Rechner (Luftfracht Florida → Deutschland)
   sections/usparts-luftfracht-rechner.liquid

   Preismodell: Preisblatt Weiterleitung, Stand 29.09.2026 (R573),
   im Cockpit hinterlegt unter einstellungen.weiterleitung.stufen.
   Rechnet im Browser, ohne Netz:
     Volumengewicht = L × B × H (cm) ÷ 5.000
     Frachtgewicht  = je Karton max(Gewicht, Volumengewicht), zusammen-
                      gezählt (R573d, Marcel 29.09., Leitstand Nr. 39 —
                      das Cockpit rechnet dieselbe Regel).
     Klasse         = erste Klasse, deren „bis kg" das Frachtgewicht trägt.
                      Nur das Frachtgewicht zählt — keine Längen-, keine
                      Gurtmaßgrenze.
     Klassenpreis   = „Versand- und Dokumentenpauschale" der Klasse.
     Dazu höchstens drei Posten:
                      Übergröße      längste Seite ≥ 120 cm, einmal je Sendung
                      Konsolidierung je WEITERER BESTELLUNG (R573) —
                                     mehrere Kartons derselben Bestellung
                                     lösen keine Konsolidierung aus
                      Versicherung   2 % vom Warenwert (mind. 5 €) + 15 €;
                                     Pflicht ab 300 € → eingerechnet,
                                     darunter nur Hinweis „auf Wunsch",
                                     über 2.500 € nicht versicherbar
     Einzelangebot  = Frachtgewicht über der letzten Klasse (70 kg) ODER
                      längste Seite über 200 cm → kein Preis, das Formular.
     Anzahlung      = die der Klasse; vor der Adressvergabe, voll angerechnet.
     USt            = netto × 19 %. Privat sieht den Endpreis brutto
                      (§ 3 PAngV), Gewerbe netto mit „zzgl. USt".
     Abgaben        = beim Zusteller, NICHT Teil unseres Preises:
                      Basis = Warenwert + US-Versand + unser Preis netto
                              (= Wert auf der Commercial Invoice, R573)
                      Zoll  = Basis × 4,5 %
                      EUSt  = (Basis + Zoll) × 19 %
                      + Verzollungsgebühr des Zustellers
   Alle Zahlen kommen aus den Section-Einstellungen (JSON im Markup),
   nichts steht hier fest. Eine Zahl je Schätzung, keine Spanne.

   KURS: steht als Section-Einstellung (derzeit 0,87) und gehört
   regelmäßig nachgesehen. Ein zu hoher Kurs bläht den Warenwert auf und
   damit Zoll UND Einfuhrsteuer — die Weiterleitung sähe teurer aus, als
   sie ist.

   Das Ergebnis ist eine SCHÄTZUNG. Die Pflichttexte dazu stehen im
   Markup der Section — hier wird keiner davon umformuliert.

   Der Knopf unter dem Ergebnis öffnet das eigene Formular der Section
   und füllt dessen versteckte Felder (Karton, Gewicht, Warenwert,
   Schätzung). Gesendet wird es von usparts.js (initAjaxContact).
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-usp-lf]');
  if (!root) return;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var cfg;
  try { cfg = JSON.parse(root.querySelector('[data-usp-lf-config]').textContent); } catch (_) { return; }

  /* ---------- Rechenkern (Schätzung) ---------- */
  var pos = function (n) { n = typeof n === 'string' ? parseFloat(n.replace(',', '.')) : n; return typeof n === 'number' && isFinite(n) && n > 0 ? n : 0; };
  var c2 = function (n) { return Math.round(n * 100) / 100; };

  /* Klassen aus der Einstellung, aufsteigend nach „bis kg". Eine Klasse
     ohne Grenze fällt weg; eine ohne Preis führt zum Einzelangebot. */
  function klassenVon(k) {
    return (k.klassen || [])
      .map(function (x) { return { nr: x.nr, name: String(x.name || ''), maxKg: pos(x.maxKg), preis: pos(x.preis), anzahlung: pos(x.anzahlung) }; })
      .filter(function (x) { return x.maxKg > 0; })
      .sort(function (a, b) { return a.maxKg - b.maxKg; });
  }

  /* e = { kartons: [{ l, b, h, kg }], bestellungen, usd, versandUsd }.
     R573b · Jeder Karton mit eigenen Maßen und eigenem Gewicht (Marcel 29.09.:
     „komisch mit den mehreren Paketen“). R573d · Frachtgewicht = Σ je Karton
     max(Gewicht, Volumengewicht), auf Cent je Karton wie im Cockpit
     (paketKennzahlen). Marcel 29.09.: „Gerne Einzelkarton, aber wenn eine
     Bestellung aus 2 Kartons besteht, nicht unbedingt Konsolidierung
     berechnen.“ Gemeinsame Prüffälle mit dem Cockpit: 20×20×20/20 kg +
     100×50×50/3 kg → 70 kg (Klasse 6) · 2× 12×12×12 in, 58/38 lb →
     43,55 kg (Klasse 5) · 110×60×35/20 kg → 46,2 kg. `bestellungen` = wie viele
     Bestellungen zusammengeführt werden, höchstens so viele wie Kartons.
     k = die Einstellungen. */
  function rechne(e, k) {
    var warnungen = [];
    var kartons = (e.kartons || []).filter(function (x) { return pos(x.l) && pos(x.b) && pos(x.h) && pos(x.kg); });
    var n = Math.max(1, kartons.length);
    var bestellungen = Math.min(n, Math.max(1, Math.round(pos(e.bestellungen)) || 1));
    var laengsteSeite = kartons.reduce(function (m, x) { return Math.max(m, pos(x.l), pos(x.b), pos(x.h)); }, 0);
    var gewicht = c2(kartons.reduce(function (s, x) { return s + pos(x.kg); }, 0));
    var volumenKg = c2(kartons.reduce(function (s, x) { return s + (pos(x.l) * pos(x.b) * pos(x.h)) / 5000; }, 0));
    var fg = c2(kartons.reduce(function (s, x) { return s + Math.max(c2(pos(x.kg)), c2((pos(x.l) * pos(x.b) * pos(x.h)) / 5000)); }, 0));
    /* Für die Waage: Welche Seite zählt bei mindestens einem Karton? Bei
       gemischten Sendungen zählen beide, je Karton eine. */
    var gewichtZaehlt = kartons.some(function (x) { return pos(x.kg) >= (pos(x.l) * pos(x.b) * pos(x.h)) / 5000; });
    var volumenZaehlt = kartons.some(function (x) { return (pos(x.l) * pos(x.b) * pos(x.h)) / 5000 > pos(x.kg); });

    var klassen = klassenVon(k);
    var grenzeKg = klassen.length ? klassen[klassen.length - 1].maxKg : 0;
    var maxLaenge = pos(k.maxLaengeCm);
    var treffer = null;
    for (var i = 0; i < klassen.length; i++) { if (fg <= klassen[i].maxKg) { treffer = klassen[i]; break; } }

    var grund = [];
    if (!treffer) grund.push('gewicht');
    if (maxLaenge > 0 && laengsteSeite > maxLaenge) grund.push('laenge');
    if (treffer && !grund.length && treffer.preis <= 0) grund.push('ohne_preis');
    var einzelangebot = grund.length > 0;
    if (einzelangebot) warnungen.push('einzelangebot');
    var klasse = einzelangebot ? null : treffer;

    var ustSatz = pos(k.ustProzent) / 100;
    var warenwertEur = c2(pos(e.usd) * pos(k.kurs));
    var versandEur = c2(pos(e.versandUsd) * pos(k.kurs));

    /* Transportversicherung: was sie bei diesem Warenwert kosten würde */
    var versPreis = warenwertEur > 0
      ? c2(Math.max(pos(k.versicherungMin), c2(warenwertEur * pos(k.versicherungSatz) / 100)) + pos(k.versicherungBearbeitung))
      : 0;
    var versicherungStatus = 'ohne_warenwert';
    if (warenwertEur > 0) {
      if (pos(k.versicherungDeckel) > 0 && warenwertEur > pos(k.versicherungDeckel)) { versicherungStatus = 'nicht_versicherbar'; warnungen.push('nicht_versicherbar'); }
      else if (warenwertEur >= pos(k.versicherungPflichtAb)) versicherungStatus = 'pflicht';
      else versicherungStatus = 'wunsch';
    }

    var kleinteil = warenwertEur > 0 && warenwertEur < pos(k.kleinteilGrenze);
    if (kleinteil) warnungen.push('kleinteil');

    var basisErg = {
      pakete: n, bestellungen: bestellungen, versandEur: versandEur, kg: gewicht, gewichtZaehlt: gewichtZaehlt, volumenZaehlt: volumenZaehlt, volumenKg: volumenKg, fg: fg, laengsteSeite: laengsteSeite,
      grenzeKg: grenzeKg, maxLaengeCm: maxLaenge,
      warenwertEur: warenwertEur, versicherungStatus: versicherungStatus,
      einzelangebot: einzelangebot, einzelangebotGrund: grund, warnungen: warnungen
    };
    if (!klasse) {
      return Object.assign(basisErg, {
        klasse: null, klassenpreis: 0, uebergroesse: 0, konsolidierung: 0, versicherung: 0, versicherungWunsch: 0,
        netto: 0, ust: 0, brutto: 0, anzahlung: { netto: 0, brutto: 0 }, abgaben: null, gesamt: 0, vorsteuer: 0
      });
    }

    var klassenpreis = klasse.preis;
    var uebergroesse = laengsteSeite >= pos(k.uebergroesseAbCm) && pos(k.uebergroesseAbCm) > 0 ? pos(k.uebergroesse) : 0;
    var konsolidierung = c2((bestellungen - 1) * pos(k.konsolidierung));
    var versicherung = versicherungStatus === 'pflicht' ? versPreis : 0;

    var netto = c2(klassenpreis + uebergroesse + konsolidierung + versicherung);
    var ust = c2(netto * ustSatz);
    var brutto = c2(netto + ust);

    /* Abgaben beim Zusteller — Basis ist Warenwert + US-Versand + unser
       Preis NETTO, auch bei Privatkunden (R573: auf der CI steht der Preis
       der ganzen Dienstleistung). Gerundet wie im Cockpit: Zoll auf Cent,
       EUSt auf (Basis + gerundeter Zoll). */
    var basis = c2(warenwertEur + versandEur + netto);
    var zoll = c2(basis * pos(k.zollProzent) / 100);
    var eust = c2((basis + zoll) * pos(k.eustProzent) / 100);
    var verzollung = pos(k.verzollung);
    var abgaben = { basis: basis, zoll: zoll, eust: eust, verzollung: verzollung, summe: c2(zoll + eust + verzollung) };

    return Object.assign(basisErg, {
      klasse: { nr: klasse.nr, name: klasse.name, maxKg: klasse.maxKg },
      klassenpreis: klassenpreis, uebergroesse: uebergroesse, konsolidierung: konsolidierung,
      versicherung: versicherung, versicherungWunsch: versicherungStatus === 'wunsch' ? versPreis : 0,
      netto: netto, ust: ust, brutto: brutto,
      anzahlung: { netto: klasse.anzahlung, brutto: c2(klasse.anzahlung * (1 + ustSatz)) },
      abgaben: abgaben,
      gesamt: c2(warenwertEur + versandEur + brutto + abgaben.summe),
      vorsteuer: c2(ust + eust)
    });
  }
  /* ---------- Ende Rechenkern ---------- */

  var ustSatz = pos(cfg.ustProzent) / 100;
  var mitUst = ustSatz > 0;

  function eur(n, dez) {
    var d = dez == null ? 2 : dez;
    return n.toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d }) + '\u00a0€';
  }
  function kg(n) { return n.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' kg'; }
  function zahl(n) { return pos(n).toLocaleString('de-DE'); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* Brutto einer Zeile = netto × (1 + USt), auf Cent gerundet */
  function br(n) { return c2(n * (1 + ustSatz)); }

  function grundText(erg) {
    var t = [];
    if (erg.einzelangebotGrund.indexOf('gewicht') >= 0) t.push('über ' + zahl(erg.grenzeKg) + ' kg Frachtgewicht');
    if (erg.einzelangebotGrund.indexOf('laenge') >= 0) t.push('längste Seite über ' + zahl(erg.maxLaengeCm) + ' cm');
    if (erg.einzelangebotGrund.indexOf('ohne_preis') >= 0) t.push('ohne Listenpreis');
    return t.join(' · ');
  }
  function klasseText(erg) { return 'Klasse ' + erg.klasse.nr + (erg.klasse.name ? ' · ' + erg.klasse.name : ''); }

  /* ---------- Felder ---------- */
  var feld = function (k) { return root.querySelector('[data-usp-lf="' + k + '"]'); };
  var el = function (k) { return root.querySelector('[data-usp-lf-' + k + ']'); };
  var hidden = function (k) { return root.querySelector('[data-usp-lf-h="' + k + '"]'); };
  /* R573b · Kartonzeilen: jede trägt dieselben data-usp-lf="l/b/h/kg" —
     `feld()` findet damit die erste (usp-r550.js fasst sie zusammen). */
  var kartonZeilen = function () { return Array.prototype.slice.call(root.querySelectorAll('[data-usp-lf-karton]')); };
  var wertIn = function (zeile, k) { var f = zeile.querySelector('[data-usp-lf="' + k + '"]'); return f ? pos(f.value) : 0; };
  function lesen() {
    var typ = root.querySelector('input[name="usp-lf-typ"]:checked');
    var kartons = [], leer = [], ersteVoll = false;
    kartonZeilen().forEach(function (z, i) {
      var x = { l: wertIn(z, 'l'), b: wertIn(z, 'b'), h: wertIn(z, 'h'), kg: wertIn(z, 'kg') };
      var voll = x.l > 0 && x.b > 0 && x.h > 0 && x.kg > 0;
      if (voll) kartons.push(x); else if (i > 0) leer.push(i + 1);
      if (i === 0) ersteVoll = voll;
    });
    var erster = kartons[0] || { l: 0, b: 0, h: 0, kg: 0 };
    return {
      kartons: kartons, leer: leer, ersteVoll: ersteVoll,
      l: erster.l, b: erster.b, h: erster.h, kg: erster.kg, pakete: Math.max(1, kartons.length),
      bestellungen: feld('bestellungen') ? Math.min(5, Math.max(1, Math.round(pos(feld('bestellungen').value) || 1))) : 1,
      usd: pos(feld('usd').value), versandUsd: feld('versand') ? pos(feld('versand').value) : 0, teil: (feld('teil') && feld('teil').value || '').trim(),
      gewerbe: !!(typ && typ.value === 'gewerbe')
    };
  }
  /* Rechnen, sobald der ERSTE Karton vollständig ist; weitere, noch leere
     Zeilen zählen erst mit Maßen und Gewicht (Hinweis in der Anzeige). */
  function vollstaendig(e) { return e.ersteVoll; }
  var kartonText = function (x) { return x.l + ' × ' + x.b + ' × ' + x.h + ' cm, ' + kg(x.kg); };
  /* Versicherungspflicht ab 300 € (AGB) — in Dollar beim eingestellten Kurs */
  var pflichtUsd = function () { return pos(cfg.kurs) ? Math.round(pos(cfg.versicherungPflichtAb) / pos(cfg.kurs)) : 0; };
  var pflichtText = function () { return 'Pflicht ab ' + eur(pos(cfg.versicherungPflichtAb), 0) + ' Warenwert' + (pflichtUsd() ? ' (≈ ' + pflichtUsd().toLocaleString('de-DE') + ' $ beim heutigen Kurs)' : ''); };

  /* ---------- Anzeige ---------- */
  var status = el('status'), waage = el('waage'), stufeBox = el('stufe'), hinweise = el('hinweise'), ergebnis = el('ergebnis');
  var flug = root.querySelector('[data-usp-lf-flug]');
  var letztes = null;

  function zeile(k, v, klasse) {
    return '<div class="usp-lf__zeile' + (klasse ? ' ' + klasse : '') + '"><dt>' + k + '</dt><dd>' + v + '</dd></div>';
  }

  /* Die versteckten Felder des Anfrageformulars — bei jeder Rechnung frisch,
     damit das Formular nie eine ältere Schätzung mitschickt. */
  function formularFuellen(erg, e) {
    var set = function (k, v) { var h = hidden(k); if (h) h.value = v; };
    /* R573b · Alle Kartons lesbar in den bestehenden Feldern „Karton“ und
       „Gewicht“ — das Cockpit übernimmt beide als Text (shopify-formular.ts,
       masseGewicht). Ein Karton: dieselbe Form wie bisher. */
    set('karton', e.kartons.length > 1
      ? e.kartons.map(function (x, i) { return 'Karton ' + (i + 1) + ': ' + kartonText(x); }).join(' · ')
      : e.l + ' × ' + e.b + ' × ' + e.h + ' cm');
    set('gewicht', kg(erg.kg) + (e.kartons.length > 1 ? ' gesamt' : '') + ' · Frachtgewicht ' + kg(erg.fg));
    set('pakete', String(erg.pakete));
    set('bestellungen', String(erg.bestellungen));
    set('versand', e.versandUsd > 0 ? e.versandUsd.toLocaleString('de-DE') + ' USD (≈ ' + eur(erg.versandEur, 0) + ')' : '');
    set('warenwert', e.usd.toLocaleString('de-DE') + ' USD (≈ ' + eur(erg.warenwertEur, 0) + ')');
    set('kundentyp', e.gewerbe ? 'Gewerbe (USt-IdNr.)' : 'privat');
    set('teil', e.teil || '');
    var extras = [];
    if (erg.uebergroesse > 0) extras.push('Übergröße');
    if (erg.konsolidierung > 0) extras.push('Konsolidierung ' + (erg.bestellungen - 1) + '× (' + erg.bestellungen + ' Bestellungen)');
    if (erg.versicherung > 0) extras.push('Versicherung');
    var schaetzung = erg.klasse
      ? klasseText(erg) + ' · an US-Parts24 ' + eur(erg.netto) + ' netto' + (mitUst ? ' / ' + eur(erg.brutto) + ' brutto' : '')
        + ' · Anzahlung ' + eur(erg.anzahlung.netto) + ' netto · Abgaben ca. ' + eur(erg.abgaben.summe)
        + (extras.length ? ' · enthält: ' + extras.join(', ') : '')
        + (erg.versicherungStatus === 'nicht_versicherbar' ? ' · NICHT VERSICHERBAR (Warenwert)' : '')
      : 'EINZELANGEBOT · ' + grundText(erg) + ' · Frachtgewicht ' + kg(erg.fg);
    set('schaetzung', schaetzung);
    var sum = el('anfrage-sum');
    if (sum) {
      var angaben = 'Deine Angaben: ' + (e.kartons.length > 1
          ? e.kartons.length + ' Kartons (' + e.kartons.map(kartonText).join('; ') + '), zusammen ' + kg(erg.kg)
          : e.l + ' × ' + e.b + ' × ' + e.h + ' cm · ' + kg(e.kg) + ' · 1 Karton')
        + (erg.bestellungen > 1 ? ' aus ' + erg.bestellungen + ' Bestellungen' : '') + ' · ' + e.usd.toLocaleString('de-DE') + ' USD'
        + (e.versandUsd > 0 ? ' + ' + e.versandUsd.toLocaleString('de-DE') + ' USD Versand' : '');
      sum.textContent = erg.klasse
        ? angaben + ' → ' + klasseText(erg) + ', ' + (mitUst && !e.gewerbe ? eur(erg.brutto) : eur(erg.netto) + (mitUst ? ' netto' : '')) + ' an uns, ca. ' + eur(erg.abgaben.summe) + ' Abgaben.'
        : angaben + ' → Einzelangebot (' + grundText(erg) + '). Wir rechnen es und melden uns mit einem Preis.';
      sum.hidden = false;
    }
    var ustid = el('ustid');
    if (ustid) ustid.hidden = !e.gewerbe;
  }

  function zeichnen(erg, e) {
    // Waage: erklärt, woher das Frachtgewicht kommt
    var max = Math.max(erg.kg, erg.volumenKg, 0.01);
    var real = root.querySelector('[data-usp-lf-wg="real"]'), vol = root.querySelector('[data-usp-lf-wg="vol"]');
    real.style.setProperty('--usp-lf-w', Math.round((erg.kg / max) * 100) + '%');
    vol.style.setProperty('--usp-lf-w', Math.round((erg.volumenKg / max) * 100) + '%');
    real.querySelector('.usp-lf__wg-v').textContent = kg(erg.kg);
    vol.querySelector('.usp-lf__wg-v').textContent = kg(erg.volumenKg);
    real.classList.toggle('is-zaehlt', !!erg.gewichtZaehlt);
    vol.classList.toggle('is-zaehlt', !!erg.volumenZaehlt);
    el('fg').textContent = kg(erg.fg);
    el('laenge').textContent = erg.laengsteSeite + ' cm';
    waage.hidden = false;

    // Klasse
    var sub = [];
    if (erg.klasse) {
      sub.push('bis ' + zahl(erg.klasse.maxKg) + ' kg Frachtgewicht');
      if (erg.pakete > 1) sub.push(erg.pakete + ' Kartons, eine Sendung');
      if (erg.bestellungen > 1) sub.push(erg.bestellungen + ' Bestellungen');
      if (erg.uebergroesse > 0) sub.push('Übergröße');
      stufeBox.innerHTML = '<span class="usp-lf__badge"><span class="usp-lf__badge-led"></span>' + esc(klasseText(erg)) + '</span>'
        + '<span class="usp-lf__badge-sub">' + sub.join(' · ') + '</span>';
    } else {
      stufeBox.innerHTML = '<span class="usp-lf__badge is-einzel"><span class="usp-lf__badge-led"></span>Sonderfracht · Einzelangebot</span>'
        + '<span class="usp-lf__badge-sub">' + grundText(erg) + '</span>';
    }
    stufeBox.hidden = false;

    // Hinweise
    var h = [];
    if (e.leer && e.leer.length) h.push('<li>' + (e.leer.length === 1 ? 'Karton ' + e.leer[0] + ' zählt' : 'Kartons ' + e.leer.join(', ') + ' zählen') + ' erst mit Maßen und Gewicht.</li>');
    if (erg.einzelangebot) h.push('<li class="is-warn">Für diese Größe gibt es keinen Listenpreis — solche Sendungen reisen in Holzkiste oder auf Palette. Wir rechnen sie einzeln; schick uns Maße und Gewicht, bevor du bestellst.</li>');
    if (erg.warnungen.indexOf('kleinteil') >= 0) h.push('<li class="is-warn">Bei so kleinem Warenwert lohnt sich der Weg selten — der Transport kostet ein Vielfaches des Teils. Frag uns lieber nach einem Komplettangebot, oft gibt es das Teil auch in der EU.</li>');
    if (erg.versicherungStatus === 'nicht_versicherbar') h.push('<li class="is-warn">Über ' + eur(pos(cfg.versicherungDeckel), 0) + ' Warenwert nicht versicherbar — bitte vorher mit uns abstimmen.</li>');
    if (e.gewerbe && erg.klasse) h.push('<li>Als Unternehmen mit USt-IdNr. holst du ' + (mitUst ? 'unsere Umsatzsteuer und ' : '') + 'die Einfuhrumsatzsteuer als Vorsteuer zurück — effektiv bleiben ' + eur(erg.abgaben.zoll + erg.abgaben.verzollung) + ' Abgaben.</li>');
    hinweise.innerHTML = h.length ? '<ul>' + h.join('') + '</ul>' : '';

    formularFuellen(erg, e);

    // Einzelangebot: kein Preis, keine Ergebnisblöcke — das Formular ist der Weg
    if (!erg.klasse) {
      ergebnis.hidden = true;
      status.textContent = 'Einzelangebot · ' + grundText(erg);
      root.classList.remove('is-live');
      letztes = { erg: erg, e: e };
      formularZeigen(false);
      return;
    }

    // Block „Unser Preis" — Positionen netto, dann USt je Kundentyp
    var gewerbeNetto = mitUst && e.gewerbe;
    var unser = '';
    var posten = 1;
    unser += zeile('Versand- und Dokumentenpauschale · Klasse ' + erg.klasse.nr, eur(erg.klassenpreis));
    if (erg.uebergroesse > 0) { posten++; unser += zeile('Übergröße (ab ' + zahl(cfg.uebergroesseAbCm) + ' cm)', eur(erg.uebergroesse)); }
    if (erg.konsolidierung > 0) { posten++; unser += zeile('Konsolidierung · ' + (erg.bestellungen - 1) + ' weitere Bestellung' + (erg.bestellungen - 1 === 1 ? '' : 'en'), eur(erg.konsolidierung)); }
    if (erg.versicherung > 0) { posten++; unser += zeile('Transportversicherung (' + pflichtText() + ')', eur(erg.versicherung)); }
    if (mitUst) {
      if (gewerbeNetto) {
        unser += zeile('zzgl. Umsatzsteuer ' + zahl(cfg.ustProzent) + ' % (Vorsteuer)', eur(erg.ust), 'is-sub');
      } else if (posten > 1) {
        unser += zeile('Zwischensumme netto', eur(erg.netto), 'is-sub');
        unser += zeile('Umsatzsteuer ' + zahl(cfg.ustProzent) + ' %', eur(erg.ust));
      } else {
        unser += zeile('Umsatzsteuer ' + zahl(cfg.ustProzent) + ' %', eur(erg.ust), 'is-sub');
      }
    }
    el('unser').innerHTML = unser;
    var summeK = el('summe-k');
    el('summe').textContent = eur(gewerbeNetto ? erg.netto : erg.brutto);
    if (summeK) summeK.textContent = gewerbeNetto ? 'An US-Parts24 (netto)' : mitUst ? 'An US-Parts24 (inkl. USt)' : 'An US-Parts24';
    var anz = gewerbeNetto ? eur(erg.anzahlung.netto) + ' netto zzgl. USt' : eur(mitUst ? erg.anzahlung.brutto : erg.anzahlung.netto);
    el('gebuehr').textContent = 'Davon vorab: Anzahlung ' + anz + ' vor der Adressvergabe — wird voll angerechnet, der Rest folgt nach dem Wiegen. Nimmst du die Sendung nach dem Wareneingang nicht ab, behalten wir die Anzahlung ein.';

    var vers = el('vers');
    if (vers) {
      if (erg.versicherungStatus === 'wunsch') {
        vers.textContent = 'Transportversicherung ist nicht eingerechnet — auf Wunsch ' + (gewerbeNetto ? eur(erg.versicherungWunsch) + ' netto' : eur(mitUst ? br(erg.versicherungWunsch) : erg.versicherungWunsch)) + ' bei deinem Warenwert (≈ ' + eur(erg.warenwertEur, 0) + '). ' + pflichtText().replace('Pflicht', 'Pflicht ist sie') + '.';
        vers.hidden = false;
      } else {
        vers.textContent = '';
        vers.hidden = true;
      }
    }

    // Block „Zusätzlich beim Zusteller" — nicht Teil unseres Preises
    var ab = '';
    ab += zeile('Zoll ca. ' + zahl(cfg.zollProzent) + ' % auf Warenwert' + (erg.versandEur > 0 ? ', US-Versand' : '') + ' + unseren Preis netto', eur(erg.abgaben.zoll));
    ab += zeile('Einfuhrumsatzsteuer ' + zahl(cfg.eustProzent) + ' %' + (e.gewerbe ? ' (Vorsteuer)' : ''), eur(erg.abgaben.eust));
    ab += zeile('Verzollungsgebühr des Zustellers', 'ca. ' + eur(erg.abgaben.verzollung));
    el('abgaben').innerHTML = ab;
    el('abgaben-summe').textContent = 'ca. ' + eur(erg.abgaben.summe);

    el('gesamt').textContent = eur(erg.gesamt);
    el('gesamt-note').textContent = 'Teil beim Händler ' + eur(erg.warenwertEur) + (erg.versandEur > 0 ? ' + US-Versand ' + eur(erg.versandEur) : '') + ' + an uns ' + eur(erg.brutto) + (mitUst ? ' inkl. USt' : '') + ' + Abgaben ca. ' + eur(erg.abgaben.summe)
      + (e.gewerbe ? ' — davon ' + eur(erg.vorsteuer) + ' Vorsteuer, die du zurückholst' : '');
    ergebnis.hidden = false;
    status.textContent = 'Schätzung steht · Klasse ' + erg.klasse.nr + ' · ' + kg(erg.fg) + ' Frachtgewicht';
    root.classList.add('is-live');
    letztes = { erg: erg, e: e };
  }

  /* Der Flug: kurze Sequenz, dann das Ergebnis. Ohne Bewegung sofort. */
  var laufTimer = null, statusTimer = null;
  function berechnen(sofort) {
    var e = lesen();
    clearTimeout(laufTimer); clearTimeout(statusTimer);
    if (!vollstaendig(e)) {
      ergebnis.hidden = true; waage.hidden = true; stufeBox.hidden = true; hinweise.innerHTML = '';
      root.classList.remove('is-live', 'is-calc');
      status.textContent = 'Bereit · Maße und Gewicht eingeben';
      var sum = el('anfrage-sum'); if (sum) sum.hidden = true;
      return;
    }
    var erg = rechne(e, cfg);
    if (reduceMotion || sofort) { root.classList.remove('is-calc'); zeichnen(erg, e); return; }
    root.classList.add('is-calc');
    root.classList.remove('is-live');
    if (flug && flug.beginElement) { try { flug.beginElement(); } catch (_) {} }
    var texte = ['Karton wird vermessen …', 'Klasse wird bestimmt …', 'Abgaben werden gerechnet …'];
    var i = 0;
    status.textContent = texte[0];
    var weiter = function () { i++; if (i < texte.length) { status.textContent = texte[i]; statusTimer = setTimeout(weiter, 320); } };
    statusTimer = setTimeout(weiter, 320);
    laufTimer = setTimeout(function () { root.classList.remove('is-calc'); zeichnen(erg, e); }, 1050);
  }

  /* R573b · Unter dem Dollar-Feld sofort der Euro-Wert — die Versicherungs-
     pflicht gilt ab 300 € (AGB), nicht ab 300 $ (Marcel 29.09.: „Über 300 Dollar
     wird nicht Versicherung mit einberechnet“). */
  var usdEur = el('usd-eur');
  function euroZeigen() {
    if (!usdEur) return;
    var usd = pos(feld('usd').value);
    usdEur.textContent = usd > 0
      ? '≈ ' + eur(c2(usd * pos(cfg.kurs)), 0) + ' · Transportversicherung ' + pflichtText().replace(' Warenwert', '')
      : '';
  }

  var tippTimer = null;
  root.addEventListener('input', function (ev) {
    if (ev.target === feld('usd')) euroZeigen();
    if (!ev.target.closest('[data-usp-lf-eingabe]')) return;
    clearTimeout(tippTimer);
    tippTimer = setTimeout(function () { berechnen(false); }, 450);
  });
  /* Die Preisliste unten rendert Liquid und kennt den Schalter Privat/Gewerbe
     nicht. Deshalb haengt der Kundentyp hier als Klasse an der Section, und das
     CSS blendet die Netto-Zweitpreise ein. Bewusst NICHT in berechnen():
     Die Liste steht auch ohne Rechnung da, berechnen() laeuft aber erst mit
     vollstaendigen Massen. */
  function typMarkieren() {
    var t = root.querySelector('input[name="usp-lf-typ"]:checked');
    root.classList.toggle('is-gewerbe', !!(t && t.value === 'gewerbe'));
  }
  typMarkieren();

  root.addEventListener('change', function (ev) {
    if (ev.target.name === 'usp-lf-typ') { clearTimeout(tippTimer); typMarkieren(); berechnen(true); }
  });

  /* ---------- R573b · Kartonzeilen und die Frage nach den Bestellungen ---------- */
  var MAX_KARTONS = 5;
  var liste = el('kartons'), plus = el('karton-plus'), best = el('best'), bestZahl = el('best-zahl');
  var zeilenNr = 1;
  var bestJa = function () { var r = root.querySelector('input[name="usp-lf-best"]:checked'); return !!(r && r.value === 'ja'); };
  function bestSetzen(ja) {
    Array.prototype.forEach.call(root.querySelectorAll('input[name="usp-lf-best"]'), function (r) { r.checked = (r.value === 'ja') === ja; });
  }
  /* Nummern, Entfernen-Knöpfe, Zähler und die Bestellungen-Frage an die
     Zahl der Zeilen angleichen. „Nein“ = eine Bestellung. „Ja“ bei zwei
     Kartons = zwei Bestellungen; ab drei Kartons fragt ein Zähler (2 … Kartons),
     Startwert = so viele wie Kartons (eher zu hoch als zu niedrig). */
  function kartonsAbgleichen() {
    var zeilen = kartonZeilen(), n = zeilen.length;
    zeilen.forEach(function (z, i) {
      var nr = z.querySelector('[data-usp-lf-karton-nr]'); if (nr) nr.textContent = 'Karton ' + (i + 1);
      var weg = z.querySelector('[data-usp-lf-karton-weg]'); if (weg) weg.hidden = n < 2;
    });
    feld('pakete').value = String(n);
    if (plus) plus.hidden = n >= MAX_KARTONS;
    if (best) best.hidden = n < 2;
    if (n < 2) bestSetzen(false);
    var be = feld('bestellungen');
    if (be) {
      be.max = String(n);
      var v = parseInt(be.value, 10) || 1;
      if (!bestJa()) be.value = '1';
      else if (n === 2) be.value = '2';
      else if (v < 2 || v > n) be.value = String(n);
    }
    if (bestZahl) bestZahl.hidden = !(bestJa() && n > 2);
    // usp-r550.js fasst die Maße zusammen und hört auf „change“
    feld('pakete').dispatchEvent(new Event('change', { bubbles: true }));
  }
  function kartonDazu() {
    var zeilen = kartonZeilen();
    if (!liste || !zeilen.length || zeilen.length >= MAX_KARTONS) return;
    zeilenNr++;
    var neu = zeilen[0].cloneNode(true);
    Array.prototype.forEach.call(neu.querySelectorAll('input'), function (i) { i.value = ''; if (i.id) i.id = i.id.replace(/-k\d+$/, '') + '-k' + zeilenNr; });
    Array.prototype.forEach.call(neu.querySelectorAll('label[for]'), function (l) { l.htmlFor = l.htmlFor.replace(/-k\d+$/, '') + '-k' + zeilenNr; });
    liste.appendChild(neu);
    kartonsAbgleichen();
    var erstes = neu.querySelector('input'); if (erstes) { try { erstes.focus(); } catch (_) {} }
    clearTimeout(tippTimer);
    berechnen(true);
  }
  function kartonWeg(zeile) {
    if (kartonZeilen().length < 2) return;
    zeile.parentNode.removeChild(zeile);
    kartonsAbgleichen();
    clearTimeout(tippTimer);
    berechnen(true);
  }
  function aufEinenKarton() {
    kartonZeilen().slice(1).forEach(function (z) { z.parentNode.removeChild(z); });
    bestSetzen(false);
    kartonsAbgleichen();
  }
  root.addEventListener('click', function (ev) {
    if (!ev.target.closest) return;
    if (ev.target.closest('[data-usp-lf-karton-plus]')) { kartonDazu(); return; }
    var weg = ev.target.closest('[data-usp-lf-karton-weg]');
    if (weg) kartonWeg(weg.closest('[data-usp-lf-karton]'));
  });

  /* Vorlagen: ein Klick, echte Zahlen — die Beispiele aus dem Preisblatt.
     Eine Vorlage ist EIN Karton aus EINER Bestellung, ohne bekannten US-Versand. */
  function vorlageSetzen(chip) {
    aufEinenKarton();
    ['l', 'b', 'h', 'kg', 'usd'].forEach(function (k) { feld(k).value = chip.dataset[k] || ''; });
    if (feld('versand')) feld('versand').value = chip.dataset.versand || '';
    euroZeigen();
  }
  root.addEventListener('click', function (ev) {
    var chip = ev.target.closest && ev.target.closest('[data-usp-lf-preset]');
    if (!chip) return;
    vorlageSetzen(chip);
    /* Teil-Feld nur setzen, wenn es leer ist oder noch den Namen der vorigen
       Vorlage trägt — was der Kunde selbst getippt hat, bleibt stehen. */
    var teil = feld('teil');
    if (teil && (!teil.value || teil.value === teil.dataset.vonVorlage)) { teil.value = chip.dataset.name || ''; teil.dataset.vonVorlage = teil.value; }
    Array.prototype.forEach.call(root.querySelectorAll('[data-usp-lf-preset]'), function (c) { c.classList.toggle('is-on', c === chip); });
    clearTimeout(tippTimer);
    berechnen(false);
  });

  /* Zähler „Aus wie vielen Bestellungen?“ — nur bei „Ja“ und ab drei Kartons
     sichtbar, Bereich 2 … Kartons. rechne() kappt zusätzlich, falls jemand tippt. */
  root.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-usp-lf-step]');
    if (!b) return;
    var inp = feld(b.dataset.uspLfZiel || 'bestellungen');
    if (!inp) return;
    var n = kartonZeilen().length;
    inp.value = String(Math.min(n, Math.max(2, (parseInt(inp.value, 10) || 2) + parseInt(b.dataset.uspLfStep, 10))));
    clearTimeout(tippTimer);
    berechnen(false);
  });
  root.addEventListener('change', function (ev) {
    if (ev.target.name === 'usp-lf-best') { kartonsAbgleichen(); clearTimeout(tippTimer); berechnen(true); return; }
    var k = ev.target.getAttribute && ev.target.getAttribute('data-usp-lf');
    if (k === 'bestellungen') {
      var n = kartonZeilen().length;
      ev.target.value = String(Math.min(n, Math.max(2, parseInt(ev.target.value, 10) || 2)));
      clearTimeout(tippTimer); berechnen(true);
    }
  });

  /* ---------- Das eigene Formular ---------- */
  var anfrage = el('anfrage');
  function formularZeigen(scrollen) {
    if (!anfrage) return;
    var war = anfrage.hidden;
    anfrage.hidden = false;
    if (!scrollen) return;
    var ziel = anfrage;
    if (window.uspSmooth && window.uspSmooth.aktiv()) window.uspSmooth.scrollTo(ziel);
    else ziel.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    var erstes = anfrage.querySelector('input[type="text"]');
    if (erstes) setTimeout(function () { try { erstes.focus({ preventScroll: true }); } catch (_) {} }, war ? 700 : 300);
  }
  var cta = el('cta');
  if (cta) cta.addEventListener('click', function () {
    if (letztes) formularFuellen(letztes.erg, letztes.e);
    formularZeigen(true);
  });

  /* Start: nie ein leerer Rechner. Erste Vorlage rein, sofort gerechnet. */
  var erster = root.querySelector('[data-usp-lf-preset]');
  if (cfg.startMitVorlage && erster && !vollstaendig(lesen())) {
    vorlageSetzen(erster);
    if (feld('teil') && !feld('teil').value) { feld('teil').value = erster.dataset.name || ''; feld('teil').dataset.vonVorlage = feld('teil').value; }
    erster.classList.add('is-on');
    berechnen(true);
  } else {
    kartonsAbgleichen();
    berechnen(true);
  }
  euroZeigen();

  /* Klassisch gepostet (ohne fetch) → das Formular offen lassen, damit die Meldung sichtbar ist */
  if (anfrage && (anfrage.querySelector('.usp-success') || anfrage.querySelector('.usp-error'))) formularZeigen(true);
})();
